<template>
  <div>
    <div class="overflow-x-auto border border-gray-100 rounded relative">
      <table class="min-w-full text-sm text-left text-gray-700">
        <thead class="bg-gray-100 uppercase text-xs font-medium text-gray-600">
          <tr>
            <th v-for="(header, index) in headers" :key="index" class="px-4 py-3">
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="loading">
            <tr v-for="n in perPage" :key="`skeleton-${n}`" class="animate-pulse">
              <td class="px-4 py-3" v-for="col in headers" :key="`skeleton-column-${col.key}`">
                <div class="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div class="h-4 bg-gray-200 rounded w-1/2"></div>
              </td>
            </tr>
          </template>

          <template v-else>
            <tr :id="rowIdFn(row)" v-for="(row, rowIndex) in rows" :key="rowIndex"
              class="border-t border-gray-200 cursor-pointer hover:bg-gray-50" @click="$emit('row-click', row)">
              <td v-for="(header, colIndex) in headers" :key="colIndex" class="px-4 py-3 overflow-visible"
                :id="cellIdFn(row, header.key)">
                <slot :name="'cell-' + header.key" :row="row" :column="header.key" :index="rowIndex">
                  {{ row[header.key] }}
                </slot>
              </td>
            </tr>

            <tr v-if="rows.length === 0">
              <td :colspan="headers.length" class="text-center py-4 text-gray-500">
                No data available
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <BasePagination :currentPage="currentPage" :totalPages="totalPages" @update:currentPage="changePage" />
  </div>
</template>

<script>
import { translations } from '@/mixins';
import BasePagination from './BasePagination.vue';

export default {
  name: "BaseTable",
  mixins: [translations],
  components: { BasePagination },
  props: {
    headers: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    perPage: {
      type: Number,
      default: 5
    },
    totalPages: {
      type: Number,
      default: 1
    },
    loading: {
      type: Boolean,
      default: false
    },
    rowIdFn: {
      type: Function,
      default: row => `row-${row.id}`
    },
    cellIdFn: {
      type: Function,
      default: (row, column) => `cell-${column}-${row.id}`
    }
  },
  data() {
    return {
      currentPage: 1
    };
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.$emit("page-changed", page);
      }
    }
  }
};
</script>
